import { BalloonEventModel } from '../../models';
import Transformer from '../../core/Transformer';
import { Organizer } from '../../types/Organizer';

export default class BeatAPIInverseBalloonEventTransformer extends Transformer<
  BalloonEventModel,
  any
> {
  constructor() {
    super();
  }

  private _transformOrganizer(organizer: Organizer | null) {
    if (organizer == null) return null;
    // Only include fields defined in v2balloons_organisers schema:
    // salutation, name, location, contactInfos
    return [{
      salutation: organizer.salutation || '',
      name: organizer.name,
      location: organizer.location,
      contactInfos: organizer.contacts,
    }];
  }

  private _transformContentType(contentType: string): string {
    // Backend expects 'plain_text' or 'html'
    if (contentType === 'text' || contentType === 'text/plain') return 'plain_text';
    if (contentType === 'text/html') return 'html';
    return contentType;
  }

  protected _transform(data: BalloonEventModel): any {
    // Transform descriptions with proper MIME content types
    const descriptions = data.complexDescription.descriptions.map((desc: any) => ({
      languageIso: desc.languageIso,
      type: desc.type,
      contentType: this._transformContentType(desc.contentType),
      content: desc.content,
    }));

    const transformedData: any = {
      name: data.title,
      descriptions,
      dates: data.dates.map((d) => {
        const transformedDate: any = {
          startDate: d.start.toISOString(),
        };
        if (d.realEnd) {
          transformedDate['endDate'] = d.realEnd.toISOString();
        }
        if (d.note) {
          transformedDate['notes'] = d.note;
        }
        return transformedDate;
      }),
      location: [
        {
          name: data.locationName,
          coordinates: {
            lat: data.location.lat,
            lng: data.location.lng,
          },
          address: data.address,
        },
      ],
      images: (data._images || []).map((img) => ({
        url: img.url,
        text: img.text || '',
        copyright: img.copyright || null,
        source_url: img.sourceUrl || null,
        license: img.license || null,
        credit_text: img.creditText || null,
      })),
      contactInfos: data.contacts,
      categories: data.categories.map((c) => {
        return c.id;
      }),
      tags: data.tags,
      organisers: this._transformOrganizer(data.organizer),
    };

    if (data.collectionId) transformedData.collectionId = data.collectionId;
    if (data.provider)
      transformedData.dataSourceProvider = data.provider.shortName;

    return transformedData;
  }
}
